import React, { useEffect, useState } from "react";
import { getOrderById } from "../services/ipeOrderService";

const IPEOrderViewDrawer = ({ orderId, onClose }) => {

  const [data, setData] = useState(null);
  const [isMaximized, setIsMaximized] = useState(false);

  useEffect(() => {
    load();
  }, [orderId]);

  const load = async () => {
    try {
      const res = await getOrderById(orderId);
      setData(res.data.data);
    } catch (e) {
      alert("Failed to load order");
    }
  };

  if (!data) return null;

  return (
    <div style={styles.overlay}>
      <div
        style={{
          ...styles.drawer,
          width: isMaximized ? "100%" : "48%"
        }}
      >

        {/* HEADER */}
        <div style={styles.header}>
          <h3>View Order</h3>

          <div style={{ display: "flex", gap: 10 }}>
            <button
              style={styles.iconBtn}
              onClick={() => setIsMaximized(!isMaximized)}
            >
              {isMaximized ? "🗗" : "⛶"}
            </button>

            <button onClick={onClose} style={styles.closeBtn}>X</button>
          </div>
        </div>

        {/* ORDER INFO (LIKE SELECTION CARD) */}
        <div style={styles.selectionCard}>
          <h4>Order Info</h4>

          <div style={styles.row}>
            <div style={styles.field}>
              <label>Customer</label>
              <input style={styles.input} value={data.customer_name || ""} disabled />
            </div>

            <div style={styles.field}>
              <label>Enquiry</label>
              <input style={styles.input} value={data.enquiry_no || ""} disabled />
            </div>

            <div style={styles.field}>
              <label>Quotation</label>
              <input style={styles.input} value={data.quotation_no || ""} disabled />
            </div>
          </div>

          <div style={{ marginTop: 10 }}>
            <b>Status:</b> {data.status_code}
          </div>
        </div>

        {/* ITEMS (MATCH CREATE TABLE STYLE) */}
        <div style={styles.section}>
          <h4>Items</h4>

          <table style={styles.table}>
            <thead>
              <tr>
                <th>SKU</th>
                <th>Description</th>
                <th>Qty</th>
                <th>Rate</th>
                <th>Amount</th>
              </tr>
            </thead>

            <tbody>
              {data.items.map((row) => {
                const amount = Number(row.quantity) * Number(row.rate);

                return (
                  <tr key={row.id}>
                    <td>
                      <input style={styles.input} value={row.id} disabled />
                    </td>

                    <td>
                      <input style={styles.input} value={row.description} disabled />
                    </td>

                    <td>
                      <input style={styles.input} value={row.quantity} disabled />
                    </td>

                    <td>
                      <input style={styles.input} value={row.rate} disabled />
                    </td>

                    <td style={{ textAlign: "right" }}>
                      {amount.toFixed(2)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* TOTAL */}
        <div style={styles.totalSection}>
          Total: ₹ {Number(data.total_amount).toFixed(2)}
        </div>

        {/* FOOTER */}
        <div style={styles.footer}>
          <button style={styles.cancelBtn} onClick={onClose}>
            Close
          </button>
        </div>

      </div>
    </div>
  );
};

// 🔷 SAME STYLES AS CREATE (COPIED)
const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    right: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.4)",
    display: "flex",
    justifyContent: "flex-end",
    zIndex: 999
  },

  drawer: {
    height: "100%",
    background: "#f4f6f9",
    padding: 20,
    overflowY: "auto",
    boxShadow: "-4px 0 15px rgba(0,0,0,0.2)",
    transition: "width 0.3s"
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 20
  },

  iconBtn: {
    background: "#e5e7eb",
    border: "none",
    padding: "6px 10px",
    cursor: "pointer",
    borderRadius: 4
  },

  closeBtn: {
    background: "#ef4444",
    color: "#fff",
    border: "none",
    padding: "6px 12px",
    borderRadius: 4,
    cursor: "pointer"
  },

  selectionCard: {
    padding: 15,
    borderRadius: 8,
    marginBottom: 20,
    background: "#ffffff",
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
  },

  row: {
    display: "flex",
    gap: 15,
    marginTop: 10
  },

  field: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: 5
  },

  section: {
    padding: 15,
    background: "#fff",
    borderRadius: 8,
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: 10
  },

  input: {
    width: "100%",
    padding: "6px 8px",
    borderRadius: 4,
    border: "1px solid #ccc"
  },

  totalSection: {
    textAlign: "right",
    marginTop: 20,
    fontSize: 18,
    fontWeight: "bold"
  },

  footer: {
    marginTop: 20,
    display: "flex",
    justifyContent: "flex-end",
    gap: 10
  },

  cancelBtn: {
    background: "#d1d5db",
    border: "none",
    padding: "8px 18px",
    borderRadius: 4,
    cursor: "pointer"
  }
};

export default IPEOrderViewDrawer;